import { createRoute, lazyRouteComponent, Outlet } from '@tanstack/react-router';
import { z } from 'zod/v3';

import { menuLayoutRoute } from 'root/MenuLayout';

import { ModalProvider } from './ModalProvider';

function VsaLayout() {
  return (
    <ModalProvider>
      <Outlet />
    </ModalProvider>
  );
}

const vsaRootRoute = createRoute({
  getParentRoute: () => menuLayoutRoute,
  id: 'vsa-root',
  component: VsaLayout,
});

const vsaRoute = createRoute({
  getParentRoute: () => vsaRootRoute,
  path: '/vsa',
  component: lazyRouteComponent(() => import('./VerticalSpecificAttributeView')),
});

export const vsaTemplateRoute = createRoute({
  getParentRoute: () => vsaRootRoute,
  path: '/vsa/templates/$templateId',
  params: z.object({ templateId: z.string() }),
  validateSearch: z.object({
    search: z.string().optional(),
    sortBy: z.enum(['name', 'slug', 'type']).optional(),
    sortingType: z.enum(['asc', 'desc']).optional(),
  }),
  component: lazyRouteComponent(() => import('./VsaTemplateAttributesView')),
});

export const vsaMappingsRoute = createRoute({
  getParentRoute: () => vsaRootRoute,
  path: '/vsa/mappings',
  validateSearch: z.object({
    mappingView: z.enum(['attributes', 'values', 'categories']).optional(),
    search: z.string().optional(),
    sortBy: z
      .enum([
        'externalAttributeId',
        'vsaSlug',
        'source',
        'externalValueId',
        'vsaAllowedValueSlug',
        'externalCategoryId',
        'templateName',
      ])
      .optional(),
    sortingType: z.enum(['asc', 'desc']).optional(),
  }),
  component: lazyRouteComponent(() => import('./VsaMappingsView')),
});

export const vsaRouteTree = vsaRootRoute.addChildren([
  vsaRoute,
  vsaTemplateRoute,
  vsaMappingsRoute,
]);
